import cn from "classnames";
import Select from "../Form/Select";
import TextInput from "../Form/TextInput";
import CheckboxForm from "../CheckboxForm";
import { getStreetOptions } from "../../utils/propertyFormOptions";

const PropertyBasicsSection = ({
  values,
  errors,
  touched,
  handleChange,
  params,
  availablePropertyCode,
  styles,
  difference,
  router,
  currentProperty,
  checkCodeAvailability,
  isAgent,
  getPropertyCategories,
  loggedAgentData,
  loggedUserAgencyType,
  agents,
  filt,
  subFilters,
  roominessInitialValue,
  cities,
}) => (
  <>
    <TextInput
      key={`form-input-propertyCode`}
      values={values}
      className={cn(
        !params.id &&
          values.property_code &&
          availablePropertyCode &&
          styles.errored,
        {
          [styles.editedObject]:
            difference.includes("property_code") &&
            router.includes("properties/edit"),
        }
      )}
      formName="property_code"
      type="number"
      handleChange={(e) => {
        handleChange(e);
        if (!params.id && currentProperty.property_code !== e.target.value) {
          checkCodeAvailability(e.target.value);
        }
      }}
      placeholder="Šifra nekretnine"
      label="Šifra Nekretnine:"
      disabled={isAgent && params.id}
      errors={errors}
      touched={touched}
    />

    {!params.id && values.property_code && availablePropertyCode && (
      <p className={styles.erroredText}>{"Šifra nekretnine je već zauzeta!"}</p>
    )}
    <Select
      key={`form-select-category`}
      values={values}
      options={getPropertyCategories()}
      formName={`category`}
      handleChange={handleChange}
      placeholder="Izaberite kategoriju nekretnine"
      label="Kategorija nekretnine:"
      errors={errors}
      touched={touched}
      ariaLabel="Kategorija nekretnine"
      disabled={
        (loggedUserAgencyType || loggedAgentData?.agencies?.[0]?.type) !==
        "sale and rental"
      }
    />
    {!isAgent && (
      <Select
        key={`form-select-agent`}
        values={values}
        options={agents.map((agent) => ({
          id: agent.id,
          label: `${agent.name}`,
        }))}
        formName="agent_id"
        handleChange={handleChange}
        placeholder="Izaberite agenta prodaje"
        label="Agent prodaje:"
        errors={errors}
        touched={touched}
        ariaLabel="Agent prodaje"
      />
    )}
    <Select
      key={`form-select-type`}
      values={values}
      options={filt.map((f) => ({
        id: f.id,
        label: f.value,
      }))}
      formName="type"
      handleChange={(e) => {
        const selectedType = e.target.value;
        values["property_sub_type"] = "";
        handleChange(e);
        values["show_roominess"] = roominessInitialValue(selectedType);
      }}
      placeholder="Izaberite tip nekretnine"
      label="* Tip nekretnine:"
      errors={errors}
      className={cn({
        [styles.editedObject]:
          difference.includes("type") && router.includes("properties/edit"),
      })}
      touched={touched}
      ariaLabel="Tip nekretnine"
    />
    <Select
      key={`form-select-propertySubType`}
      values={values}
      options={(values.type && subFilters[values.type]
        ? subFilters[values.type]
        : []
      ).map((f) => ({ id: f.id, label: f.value }))}
      formName="property_sub_type"
      className={cn({
        [styles.editedObject]:
          difference.includes("property_sub_type") &&
          router.includes("properties/edit"),
      })}
      handleChange={handleChange}
      placeholder="Izaberite podkategoriju nekretnine"
      label="* Vrsta nekretnine:"
      errors={errors}
      touched={touched}
      ariaLabel="Vrsta nekretnine"
    />
    <Select
      key={`form-select-city`}
      values={values}
      options={Object.keys(cities)
        .sort((a, b) => (a > b ? 1 : -1))
        .map((city) => ({
          id: city,
          label: city,
        }))}
      className={cn({
        [styles.editedObject]:
          difference.includes("city") && router.includes("properties/edit"),
      })}
      formName="city"
      handleChange={(e) => {
        values["area"] = "";
        handleChange(e);
      }}
      placeholder="Izaberite mesto"
      label="* Mesto:"
      errors={errors}
      touched={touched}
      ariaLabel="Mesto"
    />
    <Select
      key={`form-select-area`}
      values={values}
      options={
        values.city && cities[values.city]
          ? (cities[values.city].areas || []).map((area) => ({
              id: area.name,
              label: area.name,
            }))
          : []
      }
      formName="area"
      className={cn({
        [styles.editedObject]:
          difference.includes("area") && router.includes("properties/edit"),
      })}
      disabled={!values.city}
      handleChange={(e) => {
        values["street"] = "";
        handleChange(e);
      }}
      placeholder={!values.city ? "Prvo Izaberite Mesto" : "Izaberite Lokaciju"}
      label="* Deo grada:"
      errors={errors}
      touched={touched}
      ariaLabel="Deo grada"
    />
    <Select
      key={`form-select-street`}
      values={values}
      options={getStreetOptions({
        cities,
        city: values.city,
        area: values.area,
      })}
      className={cn({
        [styles.editedObject]:
          difference.includes("street") && router.includes("properties/edit"),
      })}
      formName="street"
      handleChange={handleChange}
      disabled={!values.area}
      placeholder={
        !values.area ? "Prvo Izaberite Deo Grada" : "Izaberite Ulicu"
      }
      label="Ulica:"
      errors={errors}
      touched={touched}
      ariaLabel="Ulica"
    />
    <CheckboxForm
      key={`form-checkbox-streetView`}
      label="Sakrij ulicu"
      formName="street_view"
      checkboxClass={cn({
        [styles.checkboxEdited]:
          difference.includes("street_view") &&
          router.includes("properties/edit"),
      })}
      handleChange={handleChange}
      values={values}
    />
  </>
);

export default PropertyBasicsSection;
